jQuery(document).ready(function ($) {
  
  
    if ($(document).scrollTop() >= 25) {
      $('header.header').addClass('js-scrolling');
    } else {
      $('header.header').removeClass('js-scrolling');
    }
    $(document).scroll(function() {
          if ($(document).scrollTop() >= 25) {
            $('header.header').addClass('js-scrolling');
           // $('.shopify-buy__cart-toggle').addClass('js-scrolling');
          } else {
            $('header.header').removeClass('js-scrolling');
          }
    });
 


//handle cart toggle position on resize
window.onresize = function() {
  if (window.innerWidth <= 1023) {  
    $( ".mobile-cart" ).append( $( ".shopify-buy-frame--toggle" ) );
  //  console.log('resize small'); 
  }else {
    $( ".shop-cart-hide-link" ).append( $( ".shopify-buy-frame--toggle" ) );
   // console.log('resize large'); 
  }
}



});